import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { useNavigate } from "react-router-dom";
import defaultAvatar from "../assets/images/committee/DefaultPhoto.svg";
import { SET_LOADING } from "../redux/user";
import { useDispatch } from "react-redux";

const base_url = "https://preview.gujaratisamajtampabay.com:3071";
const LIMIT = 50;

function Committee() {
  const [boardMembers, setBoardMembers] = useState([]);
  const [executiveMembers, setExecutiveMembers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch Members
  const fetchCommitteeMembers = async (pageNumber = 1) => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(api_paths.committee.GET_COMMITTEE_MEMBER, {
        params: { page: pageNumber, limit: LIMIT },
      });

      const { data, meta } = response?.data?.payload?.result || {};

      setPage(Number(meta?.current_page));
      setTotalPage(Number(meta?.total_pages));

      const boardList = data.filter((m) => m.is_board_of_governor === true);
      const executiveList = data.filter(
        (m) => m.is_board_of_governor === false
      );

      if (pageNumber === 1) {
        setBoardMembers(boardList);
        setExecutiveMembers(executiveList);
      } else {
        setBoardMembers((prev) => [...prev, ...boardList]);
        setExecutiveMembers((prev) => [...prev, ...executiveList]);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    } finally {
      dispatch(SET_LOADING(false)); // STOP LOADING
    }
  };

  // First load
  useEffect(() => {
    fetchCommitteeMembers(1);
    //eslint-disable-next-line
  }, []);

  // Handle View More
  const handleViewMore = () => {
    if (page < totalPage) {
      fetchCommitteeMembers(page + 1);
    }
  };

  return (
    <div style={{ background: "#FFFFFF", padding: "50px 0" }}>
      <Container>
        {/* Heading */}
        <div className="text-center mb-4">
          <h2 className="fw-bold">Meet Our Teams</h2>
          <p className="text-muted">
            Our dedicated committee members work tirelessly to bring our
            community together through cultural events and programs
          </p>
        </div>
        <hr />
        {/* board of governers Grid */}
        <h1 className="fw-bold f-20 text-main mb-4 pt-2 text-center text-sm-start">
          Executive Committee {currentYear}
        </h1>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-3 mb-5 pb-3">
          {executiveMembers.map((member) => (
            <Col key={member._id} className="d-flex">
              <div className="commitee-cards">
                <div className="commitee-img-sec">
                  <img
                    className="commiteeimg"
                    src={
                      member.picture_path
                        ? `${base_url}${member.picture_path}`
                        : defaultAvatar
                    }
                    alt={member.name}
                  />
                </div>

                <div className="my-3 text-center">
                  <h6 className="mb-0 fw-semibold fs-16 text-main">
                    {member.name}
                  </h6>
                  <p className="commitee-post">{member.position}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* executive section */}
        {boardMembers.length > 0 && (
          <>
            {" "}
            <h1 className="fw-bold f-20 text-main mb-4 pt-2 text-center text-sm-start">
              Board of Governors
            </h1>
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-3 mb-5 pb-3">
              {boardMembers.map((member) => (
                <Col key={member._id} className="d-flex">
                  <div className="commitee-cards">
                    <div className="commitee-img-sec">
                      <img
                        className="commiteeimg"
                        src={
                          member.picture_path
                            ? `${base_url}${member.picture_path}`
                            : defaultAvatar
                        }
                        alt={member.name}
                      />
                    </div>

                    <div className="my-3 text-center">
                      <h6 className="mb-0 fw-semibold fs-16 text-main">
                        {member.name}
                      </h6>
                      <p className="commitee-post">{member.position}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </>
        )}
        {/* Buttons */}
        <div className="text-center mt-3">
          <Button
            onClick={() => navigate("/past-president")}
            className="px-4 btn btn-black"
          >
            View Past Presidents
          </Button>

          {/* View More only if more pages exist */}
          {page < totalPage && (
            <Button
              onClick={handleViewMore}
              className="px-4 btn btn-orange ms-2"
              style={{ color: "#FFF" }}
            >
              View More
            </Button>
          )}
        </div>
      </Container>
    </div>
  );
}

export default Committee;
